/* eslint import/no-extraneous-dependencies: 0 */
/* eslint object-shorthand: 0 */
/* eslint func-names: 0 */
/* eslint max-len: 0 */
import * as Blockly from 'blockly';
import colors from '../utils/colors';
import options from '../utils/blocksOptions';
import { Matrix8x8Modal } from './customBlocks/matrix8x8Modal';
import { emptyLeds } from './customBlocks/matrix8x8Leds';

Blockly.Blocks.matrix8x8 = {
  init: function () {
    this.setColour(colors.COLOUR_LCD);
    this.appendDummyInput('')
      // Literal a propósito: LANG_MATRIX_8X8 ("Matriz 8x8") es el de micro:bit y
      // deja el bloque más corto que en prod.
      .appendField('Matriz 8 x 8')
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('i2c', `${this.component}_M8x8PIN`),
      ), 'M8x8PIN');
    // Centrada como en prod: la imagen es más angosta que el título y si no queda a la izquierda.
    this.appendDummyInput()
      .setAlign(Blockly.inputs.Align.CENTRE)
      .appendField(new Matrix8x8Modal({ leds: emptyLeds() }, undefined, {}), 'MATRIX');
    this.setInputsInline(false);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
  },
  getPins: function () { return ['M8x8PIN']; },
  component: 'I2C',
};

Blockly.Blocks.matrix8x8_text = {
  init: function () {
    this.setColour(colors.COLOUR_LCD);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/matrix.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_LCD_I2C);
    this.appendValueInput('NAME')
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_MATRIZ_TEXT_ON)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('i2c', `${this.component}_M8x8PIN`),
      ), 'M8x8PIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_MATRIZ_TEXT_PIN_TOOLTIP);
  },
  getPins: function () { return ['M8x8PIN']; },
  component: 'I2C',
};

Blockly.Blocks.matrix8x8_draw = {
  init: function () {
    this.setColour(colors.COLOUR_LCD);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/matrix.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_MATRIZ_8x16_TEXT_DRAW, 'LED_ON'],
        [Blockly.Msg.LANG_MATRIZ_8x16_TEXT_CLEAR, 'LED_OFF'],
      ]), 'ACTION');
    this.appendValueInput('POSX1').appendField(Blockly.Msg.LANG_LCD_I2C_POSITIONX1).setAlign(Blockly.inputs.Align.RIGHT);
    this.appendValueInput('POSY1').appendField(Blockly.Msg.LANG_LCD_I2C_POSITIONY1).setAlign(Blockly.inputs.Align.RIGHT);
    this.appendValueInput('POSX2').appendField(Blockly.Msg.LANG_LCD_I2C_POSITIONX2).setAlign(Blockly.inputs.Align.RIGHT);
    this.appendValueInput('POSY2').appendField(Blockly.Msg.LANG_LCD_I2C_POSITIONY2).setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_MATRIZ_TEXT_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('i2c', `${this.component}_M8x8PIN`),
      ), 'M8x8PIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
  },
  getPins: function () { return ['M8x8PIN']; },
  component: 'I2C',
};

Blockly.Blocks.matrix8x16_text = {
  init: function () {
    this.setColour(colors.COLOUR_LCD);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/Bhoot/14.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_LCD_I2C);
    this.appendValueInput('NAME')
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput('')
      .appendField(Blockly.Msg.LANG_MATRIZ_8x16_TEXT);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_MATRIZ_8x16_TEXT_SLOW, '0'],
        [Blockly.Msg.LANG_MATRIZ_8x16_TEXT_FAST, '1'],
      ]), 'VEL');
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_MATRIZ_8x16_TEXT_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('i2c', `${this.component}_M16x8PIN`),
      ), 'M16x8PIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_MATRIZ_8x16_TEXT_PIN_TOOLTIP);
  },
  getPins: function () { return ['M16x8PIN']; },
  component: 'I2C',
};

// Variante LGO: I2C fijo, sin selector de pin (en el legacy está comentado).
Blockly.Blocks.matrix8x8lgo = {
  init: function () {
    this.setColour(colors.COLOUR_LCD);
    this.appendDummyInput('')
      .appendField('Matriz 8 x 8');
    this.appendDummyInput()
      .setAlign(Blockly.inputs.Align.CENTRE)
      .appendField(new Matrix8x8Modal({ leds: emptyLeds() }, undefined, { variant: 'lgo' }), 'MATRIX');
    this.setInputsInline(false);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
  },
  component: 'I2C',
};
